import { graphql } from "api/cms-website/generated";

export const TabbedContentHeaderFragment = graphql(/* GraphQL */ `
    fragment TabbedContentHeaderFragment on ComponentElementsTabbedContentHeader {
        id
        title
        description
    }
`);
